export default __webpack_public_path__ + "static/media/Erika.12f89987.png";